"use client"

import { ThermometerSun } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `ThermometerSunIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const ThermometerSunIcon = component(Icon)({ as: ThermometerSun })
